// assets
import { IconListCheck } from '@tabler/icons';
import SecurityService from "services/SecurityService";
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const others = {
    id: 'others',
    title: 'Logs',
    type: 'collapse',
    children: []
};

if (SecurityService.userIsGrantedTo('event_logs')) {
    others.children.push({
        id: 'event_logs',
        title: 'Event logs',
        type: 'item',
        url: '/logs',
        icon: IconListCheck,
        breadcrumbs: false
    });  
}

if (SecurityService.userIsGrantedTo('transmission_logs')) {
    others.children.push({
        id: 'transmission_logs',
        title: 'Transmission logs',
        type: 'item',
        url: '/transmission_logs',
        icon: IconListCheck,
        breadcrumbs: false
    });    
}

export default others;
